export default __webpack_public_path__ + "static/media/img_ieguide_m.17538845.png";